const KEY = "ito-theme";

export function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
}

export function getTheme(userId) {
  if (userId) {
    const perUser = localStorage.getItem(`${KEY}:${userId}`);
    if (perUser) return perUser;
  }
  return localStorage.getItem(KEY) || "dark";
}

export function setTheme(theme, userId) {
  localStorage.setItem(KEY, theme);
  if (userId) localStorage.setItem(`${KEY}:${userId}`, theme);
  applyTheme(theme);
}
